module.exports = __webpack_public_path__ + "media/img/iphone_app-dd7bdd14.png";